import { AcSucursal } from './../dominio/acsucursal';
import { AppConfig } from './../../../../../environments/appconfig';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';

@Injectable()
export class AcSucursalService {
    private url = `${this.config.getEnv('proxy')}spring/contabilidad/acsucursal/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarActivos(): Promise<AcSucursal[]> {
        return this.http.get(`${this.url}listarActivos`,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as AcSucursal[];
            })
            .catch(error => []);
    }
}
